/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/359-omega': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M11 14h4l1-2v4h-6v-3.347c2.049-.883 3.5-3.081 3.5-5.653 0-3.35-2.462-5.973-5.5-5.973S2.5 3.649 2.5 7c0 2.572 1.451 4.77 3.5 5.653V16H0v-4l1 2h4v-.509C2.068 12.453 0 9.938 0 7c0-3.866 3.582-7 8-7s8 3.134 8 7c0 2.938-2.068 5.452-5 6.491V14z"/>'
  }
})
